module.exports = __webpack_public_path__ + "img/32.647c4326.jpg";